<template>
    <div
        :data-component-name="$options.name"
    >
        <div class="assignments-list" v-bind:key="index" v-for="(assignment, index) in assignmentsList">
            <div class="profession label-style row" v-if="!assignmentsList[index-1] || (assignmentsList[index-1].profession.name!=assignment.profession.name)">
                <div class="col">
                    {{ assignment.profession.name }}
                </div>
                <div class="col text-right -assignment-count"
                >
                    <input class="-edit-assignment-count" type="text" :value="assignmentsCount[assignment.profession.id].value"
                        @click="setFocus($event, assignment, assignmentsCount[assignment.profession.id].count)"
                        @blur="setBlur($event);"
                        @input="setValue($event, assignment, assignmentsCount[assignment.profession.id].count)"
                        :ref="'assignmentCountInput'+assignment.id"
                        :class="{'text-red': assignmentsCount[assignment.profession.id].assignedCount < assignmentsCount[assignment.profession.id].count && focused!=assignment.profession.id }"
                    >
                    <!-- <input class="-edit-assignment-count" type="text" :value="assignmentsCount[assignment.profession.id].value"
                        @focus="e => e.target.value = assignmentsCount[assignment.profession.id].count"
                        @blur="e => e.target.value = assignmentsCount[assignment.profession.id].assignedCount +'/'+ assignmentsCount[assignment.profession.id].count"
                        @input="setValue($event, assignment, assignmentsCount[assignment.profession.id].count)"
                        :ref="'assignmentCountInput'+assignment.id"
                    > -->
                </div>
            </div>
            <!-- {{ assignment.id }} -->
            <div class="assignment">
                <BestCandidateInputV2
                    v-model="assignment.assignedTo"
                    :accessLevel="accessLevel"
                    :variables="{ professions:assignment.profession.id, ...variables }"
                    :hasError="projectAssignmentWithError[assignment.id]"
                    :hasDraft="assignment.hasDraft"
                    @unassign="$emit('unassign', assignment)"
                    @remove-assignment="$emit('remove-assignment', assignment)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import orderBy from "lodash/orderBy";

    export default {
        name: 'AssignmentsList',
        props: [
            "assignments",
            "variables",
            "projectAssignmentWithError",
            "accessLevel"
        ],
        data(){
            return {
                setValueTO: null,
                selectTO: null,
                focused: null
                // assignmentsCount: {}
            }
        },
        mounted(){
        },
        methods: {
            setBlur(event){
                event.target.blur();
                this.focused=null
            },
            setFocus(event, assignement/*, value*/){
                clearTimeout(this.selectTO);
                this.selectTO=setTimeout(function(){
                    event.target.select();
                }, 100);

                this.focused=assignement.profession.id;
            },
            setValue(event, assignment, count){
                let value=event.target.value;
                if(value>100) value=100;
                clearTimeout(this.setValueTO)
                this.setValueTO=setTimeout(function(){
                    this.$emit('set-assignments-count', { profession: {id: assignment.profession.id, name: assignment.profession.name}, value: parseInt(value)-parseInt(count) } )
                }.bind(this), 500)
            }
        },
        computed: {
            assignmentsCount(){
                let assignmentsCount={};
                this.assignments.forEach(function(assignment){
                    if(!assignmentsCount[assignment.profession.id]) assignmentsCount[assignment.profession.id]={count: 0, assignedCount: 0};
                    assignmentsCount[assignment.profession.id].count++;
                    if(assignment.assignedTo) assignmentsCount[assignment.profession.id].assignedCount++;
                    assignmentsCount[assignment.profession.id].value=assignmentsCount[assignment.profession.id].assignedCount+' / '+assignmentsCount[assignment.profession.id].count;
                    if(this.focused==assignment.profession.id) assignmentsCount[assignment.profession.id].value=assignmentsCount[assignment.profession.id].count;
                }.bind(this))
                return assignmentsCount;
            },
            assignmentsList(){
                if(!this.assignments || this.assignments.length==0) return [];
                return orderBy(this.assignments, [item => item.profession.name.toLowerCase()], ['asc'])
                // return orderBy(this.assignments, [item => item.profession.name.toLowerCase(), item => item.assignedTo?.name?.toLowerCase() || '', item => item.assignedTo], ['asc', 'asc', 'desc'])
            },
        }
    }
</script>